export const LOAD_NOTIFICATIONS = 'LOAD_NOTIFICATIONS';
export const LOAD_NOTIFICATIONS_PENDING = 'LOAD_NOTIFICATIONS_PENDING';
export const LOAD_NOTIFICATIONS_FULFILLED = 'LOAD_NOTIFICATIONS_FULFILLED';
export const LOAD_NOTIFICATIONS_REJECTED = 'LOAD_NOTIFICATIONS_REJECTED';
export const RESET_STATE_TO_INITIAL_STATE = 'RESET_STATE_TO_INITIAL_STATE';
export const INCREASE_OFFSET_BY = 'INCREASE_OFFSET_BY';
